import React from 'react'
import Brand from "../../assets/Landing/Brand.png";


const Branding = () => {
  return (
    <div className='h-[1300px] '>
        <div className='h-[150px] flex items-center justify-center'>
            <p className='text-[#FF6300] w-[234px] h-[90px] text-[20px] font-semibold'> Benefits of Naayatrade </p>
        </div>
        <div className=" w-[1100px] relative flex flex-col p-4">
          <img src={Brand} alt="Brand" className="w-[700px]" />
          <div className="absolute  right-40 ">
            <h3 className=" w-[120px] h-[27px] text-lg font-semibold">Cost Savings</h3>
            <p className=" w-[380px] h-[40px] text-[16px] font-normal mt-2 ">Seamlessly manage your finances, reducing unnecessary expenses</p>
          </div>
          <div className="absolute right-10  top-1/4">
            <h3 className=" w-[220px] h-[27px] text-lg font-semibold">Streamlined Operations</h3>
            <p className="w-[380px] h-[40px] text-[16px] font-normal mt-2">Optimize your business processes for maximum efficiency</p>
          </div>
          <div className=" absolute right-60  bottom-10  ">
          <h3 className="w-[320px] h-[27px] text-lg font-semibold">Comprehensive Support</h3>
          <p className="w-[242px] h-[40px] text-[16px] font-normal mt-2">We've got your back at every stage of your journey</p>
            
          </div>
          <div className="absolute right-10 bottom-1/4 ">
            <h3 className=" w-[320px] h-[27px] text-lg font-semibold">Networking Opportunities</h3>
            <p className="w-[272px] h-[40px] text-[16px] font-normal mt-2">Connect with a global network of like-minded entrepreneurs</p>
          </div>
          <div className="absolute right-20 bottom-1/2   ">
          <h3 className="w-[200px] h-[27px] text-lg font-semibold">Secure Transactions</h3>
          <p className="w-[242px] h-[20px] text-[16px] font-normal mt-2">Rest assured that your transactions are safeguarded</p>
          </div>
        </div>
    </div>
  )
}

export default Branding
